<template>
  <div
    :style="style"
    v-touch="{
      // Disabled as it trigers when zooming. can't detect event scale
      // left: () => nextImg(),
      // right: () => prevImg(),
    }"
  >
    <div style="position: fixed; top: 15px; right: 10px">
      <v-btn
        class="csr-btn"
        style="z-index: 1"
        fab
        text
        dark
        small
        @click="closeFullMobile"
      >
        <v-icon large>close</v-icon>
      </v-btn>
    </div>

    <div :style="mobileNavCounterStyle">
      <template v-if="showOnlySelected">
        <v-row style="text-align: center; color: #757575">
          <v-col
            cols="12"
            style="height: 100px; font-size: 18px"
          >
            {{ generateImageLabel(images[selectedImageIndex]) }}
          </v-col>
          <v-col cols="1"></v-col>
          <v-col
            cols="3"
            class="mb-3"
          >
            <v-btn
              style="z-index: 1"
              class="csr-btn"
              fab
              dark
              text
              small
              @click="prevImg"
            >
              <v-icon large>chevron_left</v-icon>
            </v-btn>
          </v-col>
          <v-col
            cols="4"
            class="pt-3"
            style="font-size: 18px"
          >
            {{ selectedImageIndex + 1 }}/{{ images.length }}
          </v-col>
          <v-col cols="3">
            <v-btn
              class="csr-btn"
              style="z-index: 1"
              fab
              dark
              small
              text
              @click="nextImg"
            >
              <v-icon large>chevron_right</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="1"></v-col>
        </v-row>
      </template>
      <!-- jan 2024 decided to hide -->
      <span
        v-else
        :class="
          'd-none pika-counter ' +
          (!showingImageNavigation ? ' img-transparent' : '')
        "
        >{{ selectedImageIndex + 1 }}/{{ images.length }}
      </span>
    </div>

    <div
      :style="previewContainerStyle"
      ref="mobile-preview-full"
    >
      <div
        v-for="(image, imageIndex) in images"
        :ref="'compact-image-' + imageIndex"
        :key="imageIndex"
      >
        <div
          v-if="!showOnlySelected || imageIndex === selectedImageIndex"
          @click="changeMobileImage(image, imageIndex)"
          :ref="'thumbnail-ref-' + imageIndex"
        >
          <img
            style="width: 100%"
            :src="s3url + imgFolder + '/' + image.image"
            :class="
              'selected-compact ' +
              (imageIndex !== selectedImageIndex ? ' not-selected-compact' : '')
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import methods from '../../methods/methods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../store/state.js'
import sharedComputed from '@/methods/sharedComputed'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'ObjectImagesFullMobile',

  data: () => {
    return {
      previewScrolledTop: 0,
      showOnlySelected: false,
    }
  },

  props: {
    rooms: {
      type: Array,
      default: () => {
        return []
      },
    },
    images: {
      type: Array,
      default: () => {
        return []
      },
    },
    compact: {
      type: Boolean,
      default: false,
    },
    imgFolder: {
      type: String,
      default: null,
    },
  },

  created() {
    this.changeImage(this.images[0], 0)
    window.addEventListener('scroll', this.scrollHandler)
    // this.$nextTick(() => {
    //   const el = document.getElementById('mobile-img-holder')
    //   const hammertime = new Hammer(el, {
    //     touchAction: 'auto',
    //     // recognizers: [[Hammer.Pinch, { enable: true }, ['rotate']]],
    //   })
    //
    //   hammertime.on('swipeleft', (ev) => {
    //     console.log('swipeleft', ev)
    //     if (ev.scale !== 1) {
    //       return
    //     }
    //     this.prevImg()
    //   })
    //   hammertime.on('swiperight', (ev) => {
    //     console.log('swipeleft', ev)
    //     if (ev.scale !== 1) {
    //       return
    //     }
    //     this.nextImg()
    //   })
    //   // hammertime.on('pinch', function (ev) {
    //   //   alert(Object.keys(ev))
    //   //   console.log('pinch', ev)
    //   // })
    // })
  },

  destroyed() {
    window.removeEventListener('scroll', this.scrollHandler)
  },

  watch: {
    windowWidth(now, before) {
      if (!this.isMobileView) {
        return
      }
      if (now > before && this.windowWidth > this.windowHeight) {
        // switched to landscape
        // this.hideMobileBottomBar()
      } else if (now < before && this.windowWidth < this.windowHeight) {
        // switched to portrate
        // this.hideMobileBottomBar()
      }
    },
  },

  computed: {
    ...sharedComputed,
    ...mapFields(Object.keys(state)),

    style() {
      let style = {
        'background-color': 'rgba(255, 255, 255, 1)',
        width: '100%',
      }
      if (this.showOnlySelected) {
        style.height = '100%'
      }
      return style
    },

    imageHeight() {
      return (this.windowWidth * 3) / 4
    },

    middleScreen() {
      return this.windowHeight / 2
    },

    previewContainerStyle() {
      if (this.showOnlySelected) {
        return {
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
        }
      }
      return {
        padding: 5 + 'px 0',
      }
    },

    mobileNavCounterStyle() {
      return {
        'z-index': 1501,
        height: '50px',
        width: '100%',
        position: 'fixed',
        right: 0,
        bottom: '100px',
      }
    },
  },

  methods: {
    ...methods,

    handlePinch(event) {
      if (event.scale !== 1) {
        event.preventDefault()
      }
    },

    changeMobileImage(image, imageIndex) {
      if (this.showOnlySelected) {
        this.nextImg()
      } else {
        this.changeImage(image, imageIndex)
        this.showOnlySelected = !this.showOnlySelected
      }
    },

    closeFullMobile() {
      window.scrollTo(0, 0)
      this.closeFull()
    },

    hideMobileBottomBar() {
      alert('hideMobileBottomBar')
      window.scrollTop = window.scrollTop + 10
    },

    scrollHandler(e) {
      if (this.showOnlySelected) {
        return
      }
      const top = window.scrollY
      // const middlePoint = top + this.middleScreen
      const middlePoint = top + 50
      this.previewScrolledTop = top

      let foundIndex = -1
      // find image index which is in center
      this.images.forEach((image, index) => {
        let ref = this.$refs['compact-image-' + index][0]
        //console.log(ref.offsetTop, middlePoint, ref.offsetTop - this.imageHeight)
        //console.log(ref.offsetTop, ref.offsetTop >= middlePoint, this.imageHeight)
        if (
          ref.offsetTop <= middlePoint &&
          ref.offsetTop + this.imageHeight > middlePoint
        ) {
          foundIndex = index
        }
        if (foundIndex > -1) {
          if (this.selectedImageIndex !== foundIndex) {
            this.changeImage(this.images[foundIndex], foundIndex)
          }
        }
      })
    },
  },
}
</script>

<style>
.selected-compact {
}
.not-selected-compact {
  opacity: 1;
}
.mobile-images-close-btn {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  color: #bdbdbd !important;
  opacity: 0.7;
  border-radius: 50%;
  padding: 5px 9px;
  width: 35px;
  height: 35px;
  cursor: pointer;
}
.close-btn-with-bg {
  color: white !important;
  background: rgba(0, 0, 0, 0.7);
}
</style>
